import { useState, type FormEvent } from "react";

const FORM_URL = "https://readdy.ai/api/form/daih53boh653ivfvod9g";

type Status = "idle" | "loading" | "success" | "error";

export default function SubscribeForm() {
  const [status, setStatus] = useState<Status>("idle");
  const [message, setMessage] = useState("");

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const form = event.currentTarget;
    const formData = new FormData(form);

    const honeypot = String(formData.get("website_alt") ?? "").trim();
    if (honeypot) {
      setStatus("success");
      setMessage("订阅成功，我们会在更新时通知你。");
      form.reset();
      return;
    }
    formData.delete("website_alt");

    const body = new URLSearchParams();
    formData.forEach((value, key) => {
      body.append(key, typeof value === "string" ? value : "");
    });

    setStatus("loading");
    setMessage("");

    try {
      const response = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: body.toString(),
      });
      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null = null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }
      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || "";
      const code = parsed?.code;
      const isSpam = typeof serverMsg === "string" && serverMsg.toLowerCase().includes("spam");

      if (response.ok && code === "OK" && !isSpam) {
        setStatus("success");
        setMessage("订阅成功，我们会在更新时通知你。");
        form.reset();
      } else {
        setStatus("error");
        setMessage(serverMsg || "提交失败，请稍后再试。");
      }
    } catch {
      setStatus("error");
      setMessage("网络异常，请稍后再试。");
    }
  };

  return (
    <div className="w-full rounded-lg border border-background-200 bg-background-50 p-6 md:p-8">
      <div className="flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
          <i className="ri-notification-3-line text-xl"></i>
        </span>
        <div>
          <h3 className="font-heading text-lg font-bold text-foreground-950">订阅热点复盘更新</h3>
          <p className="mt-1 text-sm text-foreground-600">
            每周一封邮件，只发完成了时间线梳理的事件复盘，不发推送噪音。
          </p>
        </div>
      </div>

      <form data-readdy-form id="subscribe-form" onSubmit={handleSubmit} className="mt-5">
        <div className="flex flex-col gap-3 sm:flex-row">
          <label htmlFor="subscribe-email" className="sr-only">
            邮箱地址
          </label>
          <input
            id="subscribe-email"
            type="email"
            name="email"
            required
            placeholder="请输入你的邮箱地址"
            className="w-full flex-1 rounded-md border border-background-300 bg-background-50 px-4 py-3 text-sm text-foreground-900 outline-none transition-colors placeholder:text-foreground-400 focus:border-primary-400 focus:ring-2 focus:ring-primary-200"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="form-verify-field"
          />
          <button
            type="submit"
            disabled={status === "loading"}
            className="whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 disabled:cursor-not-allowed disabled:opacity-60"
          >
            {status === "loading" ? "提交中..." : "立即订阅"}
          </button>
        </div>
        {status === "success" && (
          <p className="mt-3 flex items-center gap-1.5 text-sm text-secondary-700">
            <i className="ri-checkbox-circle-line"></i>
            {message}
          </p>
        )}
        {status === "error" && (
          <p className="mt-3 flex items-center gap-1.5 text-sm text-primary-700">
            <i className="ri-error-warning-line"></i>
            {message}
          </p>
        )}
      </form>
    </div>
  );
}